<template>
  <div class="sidebar-content">
    <transition name="fade">
      <!-- to="/home" -->
      <span v-if="collapse" class="sidebar-logo-link">
        <img :src="logo" v-if="logo" :title="title" class="sidebar-logo" />
        <h1 v-else class="sidebar-title">{{ title }}</h1>
      </span>
      <span v-else class="sidebar-logo-link">
        <img :src="logo" v-if="logo" alt class="sidebar-logo" />
        <h1 class="sidebar-title">{{ title }}</h1>
      </span>
    </transition>
  </div>
</template>
<script>
export default {
  name: "Logo",
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      title: "EPOCH You Chose",
      logo: "http://www.110c.net/frames/resource/images/elogo200x192.png"
    };
  },
  methods: {}
};
</script>
<style lang="less" scoped>
.sidebar-content {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background-color: #263445;
  text-align: center;
  overflow: hidden;
  position: relative;
  transition: all 0.5s;
}
.sidebar-logo-link {
  height: 100%;
  width: 100%;
  .sidebar-logo {
    margin-right: 0;
    width: 32px;
    height: 32px;
    vertical-align: middle;
  }
  .sidebar-title {
    display: inline-block;
    color: #fff;
    margin: 0;
    font-size: 14px;
    padding-left: 5px;
  }
}
</style>
